import { useCallback, useEffect, useRef, useState } from 'react';

export const useCountUp = () => {
  const [timerCountUp, setTimerCountUp] = useState(0);
  const timer = useRef({
    startedDate: 0,
    totalMilliseconds: 0,
    interval: {} as NodeJS.Timer
  });

  const clearTimer = useCallback(() => {
    clearInterval(timer.current.interval);
  }, []);

  useEffect(() => clearTimer, [clearTimer]);

  const run = useCallback(() => {
    if (timer.current.startedDate) {
      return;
    }

    timer.current.startedDate = new Date().getTime();
    timer.current.interval = setInterval(() => {
      const time = new Date().getTime() - timer.current.startedDate + timer.current.totalMilliseconds;
      setTimerCountUp(Math.floor(time / 1000));
    }, 100);
  }, []);

  const startCountUp = useCallback(() => {
    setTimerCountUp(0);
    timer.current.totalMilliseconds = 0;
    run();
  }, [run]);

  const pauseCountUp = useCallback(() => {
    if (!timer.current.startedDate) {
      return;
    }

    clearTimer();
    timer.current.totalMilliseconds += new Date().getTime() - timer.current.startedDate;
    timer.current.startedDate = 0;
  }, [clearTimer]);

  const resumeCountUp = useCallback(() => {
    run();
  }, [run]);

  const resetCountUp = useCallback(() => {
    setTimerCountUp(0);
    timer.current.startedDate = 0;
    timer.current.totalMilliseconds = 0;
    clearTimer();
  }, [clearTimer]);

  return { timerCountUp, startCountUp, pauseCountUp, resumeCountUp, resetCountUp };
};
